var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"hl-btn",class:[
    {
      ' inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-apple-500 hover:bg-apple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-apple-500 ':
        _vm.use === 'primary',
    },
    {
      'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded shadow-sm text-apple-500 bg-apple-200 hover:bg-apple-300 hover:text-apple-600 focus:outline-none':
        _vm.use === 'primary-light',
    },
    {
      'inline-flex items-center px-4 py-2 border-2 border-curious-blue-400 text-sm font-medium rounded text-curious-blue-500 hover:bg-curious-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-curious-blue-500':
        _vm.use === 'secondary',
    },
    {
      'inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-curious-blue-500':
        _vm.use === 'outline',
    },

    {
      'inline-flex items-center px-4 py-2 border-transparent text-sm font-medium rounded shadow-sm text-red-500 bg-red-200 hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500':
        _vm.use === 'danger',
    },
    {
      'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded text-white bg-curious-blue-500 hover:bg-curious-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-curious-blue-600':
        _vm.use === 'tertiary',
    },
    {
      'cursor-not-allowed': _vm.loading
    }
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled}},_vm.eventsItems),[(_vm.loading)?_c('svg',{staticClass:"animate-spin -ml-1 mr-3 h-5 w-5",class:[
      {
        'text-white' : _vm.use === 'primary'
      },
      {
        'text-curious-blue-500' : _vm.use === 'secondary'
      },
      {
        'text-gray-700' : _vm.use === 'outline'
      },
      {
        'text-white' : _vm.use === 'danger'
      }
    ],attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"opacity-25",attrs:{"cx":"12","cy":"12","r":"10","stroke":"currentColor","stroke-width":"4"}}),_c('path',{staticClass:"opacity-75",attrs:{"fill":"currentColor","d":"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}})]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }